export interface ICompleteHandler {
  complete(data: any): void;
}
